const queryKey = {
  USER_INFO: "user_info",
  EVENT_LIST: "event_list",
  EVENT_APPLY_RECORD: "event_apply_record",
  HELP_LIST: "help_list",
  SUBORDINATE_BASIC_INFO: "subordinate_basic_info",
  SUBORDINATE_USER_DATA: "subordiante_user_data",
  SUBORDINATE_USER_DETAIL_DATA: "subordiante_user_detail_data",
  UNREAD_COUNT: "unread_conut",
  MESSAGE_LIST: "message_list",
  ANNOUNCE_LIST: "announce_list",
  OVERVIEW: "overview",
  DOWNLINE_OVERVIEW: "downline_overview",
  NEW_REGISTER: "new_register",
  FIRST_DEPOSIT: "first_deposit",
  DEPOSIT_BET: "deposit_bet",
  AGENT_BALANCE: "agent_balance",
  HOME_OVERVIEW: "home_overview",
  COMISSION_HEADER: "comission_header",
  COMISSION_WIN_LOSS: "comission_win_loss",
  COMISSION_PLATFORM_FEE: "comission_platform_fee",
  COMISSION_PROMO_FEE: "comission_promo_fee",
  COMISSION_LEVEL: "comission_level",
  CURRENCY_LIST: "currency_list",
  LANG_LIST: "lang_list",
  CS_LINK: "cs_link",
  FINANCIAL_REPORT: "financial_report",
  FINANCIAL_REPORT_DETAIL: "financial_report_detail",
  PRODUCT_REPORT: "product_report",
  PRODUCT_REPORT_DETAIL: "product_report_detail",
  OPENED_GAME: "opened_game",
  OPENED_GAME_CATEGORY: "opened_game_category",
  WITHDRAW_LIST: "withdraw_list",
  RECEIVED_LIST: "received_list",
  AGENT_STATUS: "agent_status",
  CS_LINK_APPLY: "cs_link_apply",
  AREA_CODE: "area_code",
  PRODUCT_OVERVIEW: "product_overview",
  NOW_TIMEZONE: "now_timezone",
  PROMO_ACTIVE_USER: "promo_active_user",
  AGENT_FEE_BONUS: "agent_fee_bonus",
  AGENT_FEE_BET_BONUS: "agent_fee_bet_bonus",
  AGENT_FEE_LEVEL_BONUS: "agent_fee_level_bonus",
  BET_INQUIRY: "bet_inquiry",
  BET_INQUIRY_GAMES: "bet_inquiry_games",
  BET_INQUIRY_SUB_GAMES: "bet_inquiry_sub_games",
  BET_INQUIRY_ALL_SUB_GAMES: "bet_inquiry_all_sub_games",
  PROMO_EXTRA_BONUS: "promo_extra_bonus",
  AGENT_PROMO_ACTIVE_SETTING: "promo_active_setting",

  AGENT_REBATE_LEVEL: "agent_rebate_level",
  DEPOSIT_REBATE_RATE: "deposit_rebate_rate",
  REBATE_MODE: "rebate_mode",
  SUMMARY: "summary",
  NET_LOSS_PROGRESS: "net_loss_progress",
};

export default queryKey;
